import { useCallback } from "react";
import { createNotification } from "../../../common/components";
import { translate } from "../../../common/providers";

export function usePhaseDialogs({
	setOpenPhaseDialog,
	setIsNew,
	setTempPhase,
	setEditingPhaseId,
	setOpenHistoryPanel,
	setHistoryPhase,
	setOpenAssociatedPanel,
	setAssociatedPhaseId,
	setAssociatedPhaseImported,
	setOpenImportHeritage,
	setImportPhase,
	editingPhaseId,
}) {
	const handleClickAdd = useCallback(() => {
		if (editingPhaseId !== null) {
			createNotification({
				type: "warning",
				message: translate("project-phases.edit.in-progress"),
			});
			return;
		}
		setOpenPhaseDialog(true);
		setIsNew(true);
		setTempPhase({});
		setEditingPhaseId("new");
	}, [editingPhaseId, setOpenPhaseDialog, setIsNew, setTempPhase, setEditingPhaseId]);

	const handleClickEdit = useCallback(
		(phase) => {
			if (editingPhaseId !== null) {
				createNotification({
					type: "warning",
					message: translate("project-phases.edit.in-progress"),
				});
				return;
			}
			setOpenPhaseDialog(true);
			setIsNew(false);
			setTempPhase({ ...phase });
			setEditingPhaseId(phase.id);
		},
		[editingPhaseId, setOpenPhaseDialog, setIsNew, setTempPhase, setEditingPhaseId]
	);

	const handleClosePhaseDialog = useCallback(() => {
		setOpenPhaseDialog(false);
		setEditingPhaseId(null);
	}, [setOpenPhaseDialog, setEditingPhaseId]);

	const handleClickHistory = useCallback(
		(phase) => {
			setHistoryPhase({ ...phase });
			setOpenHistoryPanel(true);
		},
		[setHistoryPhase, setOpenHistoryPanel]
	);

	const handleCloseHistoryPanel = useCallback(() => {
		setOpenHistoryPanel(false);
		setHistoryPhase({});
	}, [setOpenHistoryPanel, setHistoryPhase]);

	const handleOpenAssociatedPanel = useCallback(
		(phase) => {
			setAssociatedPhaseId(phase?.id || null);
			setAssociatedPhaseImported(!!phase?.imported);
			setOpenAssociatedPanel(true);
		},
		[setAssociatedPhaseId, setAssociatedPhaseImported, setOpenAssociatedPanel]
	);

	const handleCloseAssociatedPanel = useCallback(() => {
		setOpenAssociatedPanel(false);
		setAssociatedPhaseId(null);
		setAssociatedPhaseImported(false);
	}, [setOpenAssociatedPanel, setAssociatedPhaseId, setAssociatedPhaseImported]);

	const handleOpenImportHeritage = useCallback(
		(phase) => {
			setImportPhase(phase);
			setOpenImportHeritage(true);
		},
		[setImportPhase, setOpenImportHeritage]
	);

	const handleCloseImportHeritage = useCallback(() => {
		setOpenImportHeritage(false);
		setImportPhase(null);
	}, [setOpenImportHeritage, setImportPhase]);

	return {
		handleClickAdd,
		handleClickEdit,
		handleClosePhaseDialog,
		handleClickHistory,
		handleCloseHistoryPanel,
		handleOpenAssociatedPanel,
		handleCloseAssociatedPanel,
		handleOpenImportHeritage,
		handleCloseImportHeritage,
	};
}
